import { breakpoints } from '@awaze/design-system.utils.react';
export const calculateSiteUXVersion = (viewportWidth) => {
    const activeBreakpoint = breakpoints.find((breakpoint, index) => {
        switch (index) {
            case breakpoints.length - 1:
                return viewportWidth >= breakpoint;
            default:
                return (viewportWidth >= breakpoint && viewportWidth < breakpoints[index + 1]);
        }
    });
    return activeBreakpoint ? activeBreakpoint.toString() : '0';
};
/**
 * Formats a string for common data layer attributes which will lowercase,
 * remove special characters and trims extra whitespace inside and outside the
 * string
 * @param unformattedString
 * @returns
 */
export const formatDataLayerString = (unformattedString) => {
    return unformattedString
        .toLowerCase()
        .replace(/[^\w\s]/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};
/**
 * Formats a slug string to the required format for the data layer,
 * by replacing '/' with '_' for readability
 * @param unformattedString
 * @returns
 */
export const formatDataLayerSlug = (unformattedString) => {
    return unformattedString.toLowerCase().replace(/\//g, '_').trim();
};
const generateGtmScript = (id, dataLayerName) => `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','${dataLayerName}','${id}');
  `;
export const getGtmScript = (tmsId, dataLayerName) => {
    const script = document.createElement('script');
    script.innerHTML = generateGtmScript(tmsId, dataLayerName);
    return script;
};
export const getGtmBackupScript = (id) => {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${id}`);
    iframe.setAttribute('height', '0');
    iframe.setAttribute('width', '0');
    iframe.setAttribute('style', 'display:none;visibility:hidden');
    const noscript = document.createElement('noscript');
    noscript.append(iframe);
    return noscript;
};
const generatePageLoadDataLayerObject = (pageLoadDataObjectName, pageLoadDataObject) => `var ${pageLoadDataObjectName} = ${JSON.stringify(pageLoadDataObject)}`;
export const getPageLoadDataObject = (pageLoadDataObjectName, pageLoadDataObject) => {
    const script = document.createElement('script');
    script.innerHTML = generatePageLoadDataLayerObject(pageLoadDataObjectName, pageLoadDataObject);
    return script;
};
const insertPerformanceTags = () => {
    const preconnect = document.createElement('link');
    preconnect.setAttribute('rel', 'preconnect');
    preconnect.setAttribute('href', 'https://www.googletagmanager.com');
    document.head.insertBefore(preconnect, document.head.childNodes[0]);
    const dnsPrefetch = document.createElement('link');
    dnsPrefetch.setAttribute('rel', 'dns-prefetch');
    dnsPrefetch.setAttribute('href', 'https://www.googletagmanager.com');
    document.head.insertBefore(dnsPrefetch, document.head.childNodes[0]);
};
export const initTms = ({ id, gtmDataLayerName, pageLoadDataObjectName, pageLoadDataObject, }) => {
    const gtmScript = getGtmScript(id, gtmDataLayerName);
    const gtmBackupScript = getGtmBackupScript(id);
    const pageLoadDataLayerObject = getPageLoadDataObject(pageLoadDataObjectName, pageLoadDataObject);
    const initTMSEvents = document.createElement('script');
    initTMSEvents.innerHTML = 'window.tmsevents = window.tmsevents || [];';
    document.head.insertBefore(initTMSEvents, document.head.childNodes[0]);
    document.head.insertBefore(gtmScript, document.head.childNodes[0]);
    document.body.insertBefore(gtmBackupScript, document.body.childNodes[0]);
    document.body.insertBefore(pageLoadDataLayerObject, document.body.childNodes[0]);
    insertPerformanceTags();
};
export const pushToDataLayer = (eventType, eventName, eventData) => {
    window.tmsevents.push({
        event_type: eventType,
        event_name: eventName,
        ...eventData,
    });
};
//# sourceMappingURL=tms-context.utils.js.map